<template>
    <div v-if="client">
        <!-- logo script id -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Logo script id</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.curacaoSettings.logoScriptId"
                            class="input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- balance report enabled -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Send balance report (enable it in db)</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="client.settings.curacaoSettings.sendBalanceReport"
                                type="checkbox"
                                disabled
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- balance report url -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Balance report url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.curacaoSettings.balanceReportUrl"
                            class="input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../state';
import utils from '../../../../utils';
import clientService from '../../../../services/client.service';

export default {
    name: 'client-settings-curacao',
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        currencies() {
            return state.currencies.get();
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
        }
    }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/curacao.vue